import { ApiProperty } from "@nestjs/swagger";

export class UpdateBomItemDto{
    @ApiProperty()
    packingMaterialId:number;
    @ApiProperty()
    itemCategoryId?:number;
    @ApiProperty()
    itemId:number;
    @ApiProperty()
    quantity:number;
    @ApiProperty()
    toBeProcured:number;

    constructor(packingMaterialId:number, itemId:number, quantity:number, toBeProcured:number,  itemCategoryId?:number){
        this.packingMaterialId = packingMaterialId;
        this.itemCategoryId = itemCategoryId;
        this.itemId = itemId;
        this.quantity = quantity;
        this.toBeProcured = toBeProcured;
    }
}